var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.radar = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }
    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var container = $('<div class="radar">').css({ width: '90%', height: '90%', top: '5%', left: '5%' }); 

        var keys = Object.keys(data[0]);
        var values = data || 0;
        var kendoConfig = {
            legend: {
                position: "bottom"
            },
            series: [
                {
                    type: "radarLine",
                    name: keys[1],
                    categoryField: keys[0],
                    field: keys[1],
                    data: values
                }
            ],
            tooltip: {
                visible: true
            }
        };

        $.extend(true, kendoConfig, metadata.KendoConfig);

        chart.append(container);
        container.kendoChart(kendoConfig);            
    }, 0);
};